import { useMemo } from 'react'

import useLDFlags from 'data/hooks/useLDFlags'
import { EditableAttribute } from 'features/views/attributes/editable/types'
import { getSupportedTitleFields } from 'features/views/DetailView/headers/utils'
import { useDetailViewContext } from 'features/views/DetailView/hooks/useDetailViewContext'

export function useDetailViewTitleAttributeState() {
    const { header, fields } = useDetailViewContext()!

    const titleFieldApiName = header.title?.fieldApiName
    const titleField = getSupportedTitleFields(fields).find(
        (field) => field.api_name === titleFieldApiName
    )

    const field: EditableAttribute | undefined = useMemo(
        () => (titleField ? { field: titleField } : undefined),
        [titleField]
    )

    const { flags } = useLDFlags()
    const overrideIsEditable = flags.detailViewHeaderInlineEditing ? undefined : false

    return useMemo(
        () => ({
            field,
            overrideIsEditable,
        }),
        [field, overrideIsEditable]
    )
}
